import { Product, ProductStatus } from "api/schema/productsSchema";
import { productIds } from "utils";

export const getDefaultProductStatus = () => ({
  isLendingEnabled: false,
  isBankFeedsEnabled: false,
  isSyncForCommerceEnabled: false,
  isSyncForExpensesV1Enabled: false,
  isSyncForExpensesV2Enabled: false,
  isSpendInsightsEnabled: false,
});

const isEnabled = (status: ProductStatus) => status === "Enabled";

export const setEnabledStatus = (parsedProducts: Product[]) => {
  return parsedProducts.reduce((allProductsStatus, currentProduct) => {
    const { productId, status } = currentProduct;

    const {
      assess,
      lending,
      bankFeeds,
      syncForCommerce,
      syncForExpensesV1,
      syncForExpensesV2,
      syncForPayroll,
      spendInsights,
    } = productIds;

    switch (productId) {
      case assess:
      case lending:
        return {
          ...allProductsStatus,
          isLendingEnabled: isEnabled(status),
        };

      case bankFeeds:
        return {
          ...allProductsStatus,
          isBankFeedsEnabled: isEnabled(status),
        };
      case syncForCommerce:
        return {
          ...allProductsStatus,
          isSyncForCommerceEnabled: isEnabled(status),
        };
      case syncForExpensesV1:
        return {
          ...allProductsStatus,
          isSyncForExpensesV1Enabled: isEnabled(status),
        };
      case syncForExpensesV2:
        return {
          ...allProductsStatus,
          isSyncForExpensesV2Enabled: isEnabled(status),
        };
      case syncForPayroll:
        return {
          ...allProductsStatus,
          isSyncForPayrollEnabled: isEnabled(status),
        };
      case spendInsights:
        return {
          ...allProductsStatus,
          isSpendInsightsEnabled: isEnabled(status),
        };
      default:
        return allProductsStatus;
    }
  }, getDefaultProductStatus());
};
